import { BeforeAfterSlider } from "./BeforeAfter";
import beforeFloor from "@/assets/before-floor.jpg";
import afterFloor from "@/assets/flooring-hero.jpg";
import { ShieldCheck, Layers, DollarSign, ArrowRight } from "lucide-react";
import { Link } from "@tanstack/react-router";

const points = [
  { icon: Layers, title: "Subfloor done right", desc: "Cracked tile almost always starts under the surface. We level, shore, and prep the substrate before a single tile is set." },
  { icon: ShieldCheck, title: "30 years of judgment", desc: "We've installed every natural stone, tile, and porcelain Utah sells — up to 4' x 4'. We know what fails and what lasts." },
  { icon: DollarSign, title: "Done once. Done right.", desc: "Yes, we cost more than a weekend installer — and far less than the redo. Cheap floors get replaced in five years; ours stay flat for decades." },
];

export function FlooringSpotlight() {
  return (
    <section className="py-20 md:py-28 bg-cream border-y border-border">
      <div className="container-prose">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="shadow-[var(--shadow-elegant)]">
            <BeforeAfterSlider before={beforeFloor} after={afterFloor} alt="Cracked tile floor transformed into natural stone masterpiece" />
          </div>
          <div>
            <span className="eyebrow">★ Our Specialty — Flooring Installation</span>
            <h2 className="mt-3 font-display text-3xl md:text-5xl text-foreground leading-tight">
              The floor is the foundation of every room you love.
            </h2>
            <p className="mt-5 text-muted-foreground text-lg leading-relaxed">
              If you only call us for one thing, call us for floors. Large-scale natural stone, slate, marble,
              travertine, and porcelain — installed over substrates prepped to outlast everything else in your home.
            </p>
            <div className="mt-8 space-y-5">
              {points.map((p) => (
                <div key={p.title} className="flex gap-4">
                  <div className="h-11 w-11 flex-shrink-0 rounded-full bg-primary/10 flex items-center justify-center">
                    <p.icon className="h-5 w-5 text-primary" strokeWidth={1.5} />
                  </div>
                  <div>
                    <div className="font-display text-lg text-foreground">{p.title}</div>
                    <p className="text-sm text-muted-foreground leading-relaxed mt-1">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <Link to="/services" className="mt-10 inline-flex items-center gap-2 bg-primary text-primary-foreground px-7 py-4 text-sm font-semibold uppercase tracking-wider hover:bg-primary/90 transition-colors">
              See Flooring Installation <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
